import { ContentType, Method } from '../../../constants/http';
import { getTokensFromDevBoxDataPlaneUri } from '../../../ids/dev-box';
import { DevBoxHyperVPutBody } from '../../../models/add-ons';
import { DataResponse, FailureOperation } from '../../../models/common';
import {
    createFailureResponseFromAzureCoreFoundationsErrorBodyOrDefault,
    tryParseErrorResponse,
} from '../../../utilities/failure';
import { DevBoxHyperVAddOnContract } from '../../contracts/add-ons';
import { FetchOptions, fetchRequest } from '../fetch-request';

export type GetDevBoxHyperVResponse = DataResponse<DevBoxHyperVAddOnContract>;
export type CreateDevBoxHyperVResponse = DataResponse<DevBoxHyperVAddOnContract>;

// Addons is currently in private preview and there is no Data Plane SDK pacakge for this API version so we are using `fetch` instead of the SDK
// Task 2443329: Update add-ons to use Data plane SDK package when available
export const getDevBoxAddOn = async (
    id: string,
    name: string,
    accessToken: string,
    activityId?: string
): Promise<GetDevBoxHyperVResponse> => {
    const { devBoxName, projectName, user, devCenter } = getTokensFromDevBoxDataPlaneUri(id);

    const options: FetchOptions<Response> = {
        accessToken,
        activityId,
        contentType: ContentType.ApplicationJson,
    };

    const result = await fetchRequest(
        `${devCenter}/projects/${projectName}/users/${user}/devboxes/${devBoxName}/addons/${name}?api-version=2025-03-01-privatepreview`,
        Method.GET,
        options
    );

    // TODO: Change to using FailureResponse when the API is available in Data Plane SDK pacakge.
    if (result.status !== 200) {
        const errorResponse = await tryParseErrorResponse(result);
        return createFailureResponseFromAzureCoreFoundationsErrorBodyOrDefault(
            errorResponse,
            FailureOperation.GetDevBoxAddOn
        );
    }

    return { data: await result.json(), succeeded: true };
};

// Addons is currently in private preview and there is no Data Plane SDK pacakge for this API version so we are using `fetch` instead of the SDK
// TODO: Task 2443329: Update add-ons to use Data plane SDK package when available
// TODO: Task 2443953: Make a generic Add-ons api call
export const createDevBoxHyperVAddOn = async (
    id: string,
    name: string,
    body: DevBoxHyperVPutBody,
    accessToken: string,
    activityId?: string
): Promise<CreateDevBoxHyperVResponse> => {
    const { devBoxName, projectName, user, devCenter } = getTokensFromDevBoxDataPlaneUri(id);

    const options: FetchOptions<Response> = {
        activityId,
        accessToken,
        contentType: ContentType.ApplicationJson,
        body: JSON.stringify(body),
    };
    const result = await fetchRequest(
        `${devCenter}/projects/${projectName}/users/${user}/devboxes/${devBoxName}/addons/${name}?api-version=2025-03-01-privatepreview&addOnType=devboxhyperv`,
        Method.PUT,
        options
    );

    // TODO: Change to using FailureResponse when the API is available in Data Plane SDK pacakge.
    if (result.status !== 201) {
        const errorResponse = await tryParseErrorResponse(result);
        return createFailureResponseFromAzureCoreFoundationsErrorBodyOrDefault(
            errorResponse,
            FailureOperation.AddDevBoxHyperV
        );
    }

    return { data: await result.json(), succeeded: true };
};
